import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import RoomsPage from './pages/RoomsPage';
import ElectricityPage from './pages/ElectricityPage';
import MetersPage from './pages/MetersPage';
import PaymentsPage from './pages/PaymentsPage';
import ArrearsPage from './pages/ArrearsPage';
import ElectricityTrendsPage from './pages/ElectricityTrendsPage';
import ReportsPage from './pages/ReportsPage';
import TenantsPage from './pages/TenantsPage';
import MonthlyBillSummary from './pages/MonthlyBillSummary';
import AnalyticsPage from './pages/AnalyticsPage';
import DepositsPage from './pages/DepositsPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                style: {
                  background: '#10b981',
                },
              },
              error: {
                duration: 5000,
                style: {
                  background: '#ef4444',
                },
              },
            }}
          />
          
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="rooms" element={<RoomsPage />} />
              <Route path="room/:roomId/bill/:year/:month" element={<MonthlyBillSummary />} />
              <Route path="electricity" element={<ElectricityPage />} />
              <Route path="meters" element={<MetersPage />} />
              <Route path="payments" element={<PaymentsPage />} />
              <Route path="arrears" element={<ArrearsPage />} />
              <Route path="electricity-trends" element={<ElectricityTrendsPage />} />
              <Route path="tenants" element={<TenantsPage />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="analytics" element={<AnalyticsPage />} />
              <Route path="deposits" element={<DepositsPage />} />
            </Route>
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
